const properties = [
	'colorByNode',
	'showLabelOnNode',
	'dataLabelsHideableLayout',
	'sourceLabelAlignment',
	'waypointLabelAlignment',
	'targetLabelAlignment',
	'isReverseGraphEnabled',
	'showLevelName',
	'isVerticalScrollEnabled',
	'isDraggingOfNodesEnabled',
	'resetCachedNodes',
	'nodeAlignment',
	'totalHideableLayout',
	'totalAlignment',
	'showTotalOnLabel',
	'fontFamilyGlobal',
	'fontSizeGlobal',
	'fontStyleGlobal',
	'fontColorGlobal',
	'isTextWrapEnabled',
	'fontFamilyName',
	'fontSizeName',
	'fontStyleName',
	'fontColorName',
	'showName',
	'fontFamilyTotal',
	'fontSizeTotal',
	'fontStyleTotal',
	'fontColorTotal',
	'showTotal',
	'fontFamilyLevelName',
	'fontSizeLevelName',
	'fontStyleLevelName',
	'fontColorLevelName',
	'radioForNodeColorPalettes',
	'nodeColorPalette',
	'nodeColorPaletteTitle',
	'groupedNodeColor',
	'density',
	'densityMode',
	'flowFillType',
	'flowOpacityPercent',
	'flowFillColor',
	'minorValuesGroupNodes',
	'minorValuesIsHidingEnabled',
	'minorValuesHideThreshold',
	'minorValuesIsGroupEnabled',
	'minorValuesGroupLabel',
	'minorValuesGroupFrom',
	'minorValuesGroupTo',
	'overlapWarning',
	'userPalette',
	'nodeColorPaletteContainer'
];

export default properties;
